import React from "react";
import { Box } from "app/components/common";
import theme from "app/Theme/Theme";
import Svg, { Path } from "react-native-svg";
import normalize from "app/utils/normalize";

const LightningIcon = ({
  height = normalize(24),
  width = normalize(24),
  color = theme.colors["neutral.white"],
  ...props
}) => {
  return (
    <Svg
      width={width}
      height={height}
      preserveAspectRatio="xMidYMin meet"
      viewBox="0 0 24 24"
      {...props}
    >
      <Path
        d="M16.9101 9.89591C16.8079 9.7261 16.6323 9.62516 16.4446 9.62516H12.5556V3.094C12.5556 2.81375 12.3723 2.57151 12.1156 2.51332C11.8545 2.45395 11.599 2.59763 11.4923 2.85294L7.04779 13.5403C6.97112 13.7232 6.98779 13.9369 7.09001 14.1044C7.19223 14.273 7.36779 14.3751 7.55557 14.3751H11.4445V20.9063C11.4445 21.1865 11.6278 21.4287 11.8845 21.4869C11.9234 21.4952 11.9623 21.5 12.0001 21.5C12.2156 21.5 12.4167 21.3658 12.5078 21.1473L16.9523 10.46C17.0279 10.2759 17.0135 10.0645 16.9101 9.89591Z"
        fill={color}
      />
    </Svg>
  );
};

export default LightningIcon;
